
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import AppInfo from '@/util/AppInfo'

/**
 * 言語ごとに表示する内容を切り替えるために作成
 */
export default defineComponent({
  name: 'AuthUserComment',
  setup() {
    const { locale } = useI18n()
    const isSmartPhone = computed(() => {
      return AppInfo.isSmartPhone
    })
    const fluxLoginUrl = computed(() => {
      return `${process.env.VUE_APP_FLUX_LOGIN_PAGE_BASE_URL}/fl/index.html#/login`
    })
    const fluxTermsUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_TERMS_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_TERMS_PAGE_PATH}`
    })
    const fluxPrivacyPolicyUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH}`
    })
    return {
      fluxLoginUrl,
      fluxTermsUrl,
      fluxPrivacyPolicyUrl,
      isSmartPhone,
      ...useI18n(),
    }
  },
})
